import { useEffect, useState } from "react";
import { fetchAdminSettings, saveAdminSettings } from "@/villa142/api";

export default function UploadsView() {
  const [settings, setSettings] = useState(null);
  const [perFile, setPerFile] = useState("");
  const [budget, setBudget] = useState("");
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    fetchAdminSettings().then((s) => {
      setSettings(s);
      setPerFile(String(s.image_max_mb));
      setBudget(String(s.image_budget_mb));
    });
  }, []);

  const save = async () => {
    setStatus("saving");
    try {
      const s = await saveAdminSettings({
        image_max_mb: parseFloat(perFile),
        image_budget_mb: parseFloat(budget),
      });
      setSettings(s);
      setPerFile(String(s.image_max_mb));
      setBudget(String(s.image_budget_mb));
      setStatus("saved");
      setTimeout(() => setStatus("idle"), 2500);
    } catch {
      setStatus("error");
    }
  };

  if (!settings) return <div className="v142-admin-panel"><p className="v142-support">Loading…</p></div>;

  const dirty = parseFloat(perFile) !== settings.image_max_mb || parseFloat(budget) !== settings.image_budget_mb;
  const invalid = !(parseFloat(perFile) > 0) || !(parseFloat(budget) > 0);

  return (
    <div className="v142-admin-panel" data-testid="v142-uploads-view">
      <div className="v142-field-head">
        <span className="v142-label-follow">Photo uploads</span>
        <p className="v142-support">
          These limits apply to every photo field across the questionnaire. Clients see a gentle message if a photo
          is too large or if a single response goes over its budget. Voice notes and background media are unaffected.
        </p>
      </div>

      <div className="v142-uploads-grid">
        <div className="v142-mini-field">
          <label htmlFor="v142-perfile" className="v142-mini-label">Largest single photo (MB)</label>
          <input
            id="v142-perfile"
            type="number"
            min="1"
            step="1"
            className="v142-input v142-input-small"
            value={perFile}
            onChange={(e) => setPerFile(e.target.value)}
            data-testid="v142-uploads-perfile"
          />
        </div>
        <div className="v142-mini-field">
          <label htmlFor="v142-budget" className="v142-mini-label">Total photos per reflection (MB)</label>
          <input
            id="v142-budget"
            type="number"
            min="1"
            step="1"
            className="v142-input v142-input-small"
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
            data-testid="v142-uploads-budget"
          />
        </div>
      </div>

      <dl className="v142-uploads-facts">
        <div><dt>Accepted formats</dt><dd>JPEG, PNG, WebP, GIF{settings.heic_supported ? ", and iPhone HEIC/HEIF" : ""}</dd></div>
        <div><dt>iPhone photos (HEIC)</dt><dd>{settings.heic_supported ? "Supported — converted to JPEG for the studio, with optimized copies for viewing." : "Not available on this server."}</dd></div>
        <div><dt>How photos are stored</dt><dd>The accepted photo is kept for the studio to download; lighter copies are made automatically for quick, clear viewing.</dd></div>
        <div><dt>Oversized photos</dt><dd>Politely declined before uploading — never silently cropped.</dd></div>
      </dl>

      <div className="v142-recorder-actions">
        <button
          type="button"
          className="v142-btn v142-btn-small"
          data-testid="v142-uploads-save"
          onClick={save}
          disabled={!dirty || invalid || status === "saving"}
        >
          {status === "saving" ? "Saving…" : "Save limits"}
        </button>
        {status === "saved" && <span className="v142-recorder-note" role="status">Saved.</span>}
        {status === "error" && <span className="v142-error" role="alert">Could not save — please try again.</span>}
      </div>
    </div>
  );
}
